module.exports = __webpack_public_path__ + "static/media/BZ.2a7e468a.png";